<template>
  <div id="page-staff">
    <label style="font-size: 20px;margin-bottom20px;">设置要访问的分级发布层级[pub_env]: 0-全流量 1-沙盒 2-小流量</label>
    <br />
    <div style="margin-top:20px">
      <Button @click="setPubEnv(1)" size="large" style="margin-right:20px;">沙盒</Button>
      <Button @click="setPubEnv(2)" size="large" style="margin-right:20px;">小流量</Button>
      <Button @click="setPubEnv(0)" size="large">全流量</Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    setPubEnv(value) {
      var k = "pub_env";
      var v = value;
      this.setCookie(k, v, 3600000);
      this.$Message.success("设置成功");
    },
    //设置cookie
    setCookie(key, value, expiredays) {
      document.cookie =
        key +
        "=" +
        escape(value) +
        ";path=/;expires=" +
        new Date(+new Date() + expiredays).toGMTString() +
        ";domain=" +
        escape(".r360data.com");
    }
  }
};
</script>
